import React, { useEffect, useRef } from "react";
import "./RelatorioAdesividadePrint.css";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";
import useNomeArquivoPdf from "../Utils/useNomeArquivoPdf";

function formatarDataBR(data) {
  if (!data) return "";
  const [ano, mes, dia] = String(data).split("-");
  return ano && mes && dia ? `${dia}/${mes}/${ano}` : String(data);
}

function instalarEstiloPrint() {
  const id = "print-style-adesividade";
  if (document.getElementById(id)) return;
  const style = document.createElement("style");
  style.id = id;
  style.media = "print";
  style.textContent = "@page { size: A4 portrait; margin: 0; }";
  document.head.appendChild(style);
}

export default function RelatorioAdesividadePrint({ ensaio, autoPrint = false, onVoltar, onReady }) {
  const imprimiu = useRef(false);
  useNomeArquivoPdf(ensaio?.codigo ? `CE-RE-ADES-${ensaio.codigo}/2024` : "");

  useEffect(() => {
    instalarEstiloPrint();
    onReady?.();
    return () => document.getElementById("print-style-adesividade")?.remove();
  }, [onReady]);

  useEffect(() => {
    if (!autoPrint || imprimiu.current) return;
    imprimiu.current = true;
    requestAnimationFrame(() => window.print());
  }, [autoPrint]);

  return (
    <div className="relatorio-adesividade-print">
      {onVoltar && (
        <div className="acoes-print">
          <button onClick={onVoltar}>Voltar</button>
          <button onClick={() => window.print()}>Imprimir</button>
        </div>
      )}
      <main className="pagina">
        <table className="cabecalho">
          <tbody>
            <tr>
              <td rowSpan="2" className="logo-cell"><LogoRelatorio alt="Logo"  /></td>
              <td className="titulo-sgq">SISTEMA DE GESTÃO DA QUALIDADE</td>
              <td>Revisão 02</td>
            </tr>
            <tr>
              <td className="titulo-documento">Relatório de ensaio - Agregado Graúdo - Determinação da<br /><strong>adesividade ao ligante betuminoso</strong></td>
              <td>10/09/2024</td>
            </tr>
          </tbody>
        </table>

        <div className="linha-meta">
          <span><strong>DATA:</strong> {formatarDataBR(ensaio.dataEnsaio)}</span>
          <span><strong>CÓDIGO:</strong> CE-RE-ADES-{ensaio.codigo || ""}/2024</span>
        </div>
        <div className="faixa-cinza" />
        <div className="empresa">
          <p><strong>EMPRESA/CONTRATANTE:</strong> {ensaio.cliente || ""}</p>
          <p><strong>LOCAL:</strong> {ensaio.obra || ""}</p>
        </div>

        <section>
          <h2>1. OBJETIVO DO ENSAIO.</h2>
          <p>Este relatório tem por objetivo apresentar os resultados do ensaio de Determinação da adesividade ao ligante betuminoso.</p>
        </section>
        <section>
          <h2>2. METODOLOGIA.</h2>
          <p>O ensaio seguiu as prescrições da norma:<br />- DNIT 452/2024-ME - Agregado graúdo - Adesividade ao ligante asfáltico.</p>
        </section>
        <section>
          <h2>3. AMOSTRA/ENSAIO.</h2>
          <p>As amostras foram identificadas conforme abaixo:</p>
          <table className="amostras">
            <thead>
              <tr>
                <th>Código</th>
                <th>Amostra</th>
                <th>Local Coleta</th>
                <th>Procedência</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{ensaio.codigoMaterial || ""}</td>
                <td>{String(ensaio.material || "").toUpperCase()}</td>
                <td>{String(ensaio.localColeta || "").toUpperCase()}</td>
                <td>{String(ensaio.fornecedor || "").toUpperCase()}</td>
              </tr>
              {ensaio.ligantes.map((ligante, index) => (
                <tr key={index}>
                  <td>{ligante.codigoMaterial || ""}</td>
                  <td>{String(ligante.nome || "").toUpperCase()}</td>
                  <td>{String(ligante.localColeta || "").toUpperCase()}</td>
                  <td>{String(ligante.procedencia || "").toUpperCase()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        {ensaio.ligantes.map((ligante, liganteIndex) => (
          <section className="bloco-ligante" key={liganteIndex}>
            <h2>3.{liganteIndex + 1}. {ensaio.material || "Agregado"} + {ligante.nome}</h2>
            <div className="titulos-fotos"><strong>ASPECTO VISUAL ANTES:</strong><strong>ASPECTO VISUAL APÓS:</strong></div>
            {ligante.amostras.map((amostra, amostraIndex) => (
              <div className="linha-amostra" key={amostraIndex}>
                <div className="rotulo-amostra">Amostra {amostraIndex + 1}:</div>
                <div className="fotos">
                  {["antes", "depois"].map((tipo) => amostra[tipo]?.url
                    ? <img key={tipo} src={amostra[tipo].url} alt={`Amostra ${amostraIndex + 1} ${tipo}`} />
                    : <div key={tipo} className="sem-foto">Sem foto</div>
                  )}
                </div>
              </div>
            ))}
          </section>
        ))}

        <section className="consideracoes">
          <h2>5. CONSIDERAÇÕES FINAIS.</h2>
          <table>
            <thead><tr><th>Itens verificados</th><th>ADESIVIDADE</th></tr></thead>
            <tbody>
              {ensaio.ligantes.map((ligante, index) => (
                <tr key={index}>
                  <td>{ensaio.material || "Agregado"} + {ligante.nome}</td>
                  <td>{ligante.resultado || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="nota">Os resultados de ensaios e as considerações feitas neste relatório têm significado restrito às amostras analisadas e às condições em que os ensaios foram executados.</p>
        </section>

        <footer>
          <img src="/Images/assinaturaLeal.png" alt="Assinatura" />
          <div>José Carlos Lemes Leal</div>
          <div>Eng. Civil CREA 203379/D - TO</div>
        </footer>
      </main>
    </div>
  );
}
